(ns manage.content-configuration-page.view.content
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Drawer$default" :as Drawer]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.modal.dialog :refer [deletion-confirmation response-dialog]]
            [common.modal.view :refer [defmodal]]
            [common.ui.entity :as ui.entity]
            [common.ui.side-menu :as side-menu]
            [common.ui.store :as store]
            [common.widgets.page :as page]
            [linked.core :as linked]
            [manage.content-configuration-page.context-source.view
             :as context-source]
            [manage.content-configuration-page.placeholder-expression.view
             :as placeholder-expression]
            [manage.content-configuration-page.placeholder.view :as placeholder]
            [manage.content-configuration-page.rule.view :as rule]
            [manage.content-configuration-page.view.import
             :refer [import-failure import-pending]]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :refer [$ defhook defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defhook use-contains-version? [v]
  (use-subscribe [:resource.content-function-version/contains-version?
                  (name v)]))

(defhook use-active-version? [v]
  (use-subscribe [:resource.content-function-version/active-version?
                  (name v)]))

(defhook use-active-staged-version? []
  (use-subscribe [:resource.content-function-version/active-version
                  {:only-staged true}]))

(defhook use-resource-pending? [k]
  (use-subscribe [:resource.content-function/pending? k]))

(defui publish-button []
  (let [contains-version-draft (use-contains-version? :draft)
        active-staged-version  (use-active-staged-version?)]
    (when (and contains-version-draft active-staged-version)
      ($ Button
         {:on-click #(rf/dispatch [:manage.content-configuration-page.content-configuration.db/publish-if-valid])
          :start-icon ($ Icon "publish")
          :data-testid :publish-cfn-button
          :variant "text"}
         "Publish content"))))

(defmodal block-publishing ::block-publishing
  [_]
  [response-dialog
   {:modifier :error
    :title "Please check the errors to publish the content"
    :message "It is not possible to publish the content because
              there are errors in the configuration."}])

(defui create-draft-button []
  (let [contains-version-published (use-contains-version? :published)
        contains-version-draft     (use-contains-version? :draft)
        create-stage-is-pending    (use-resource-pending? :create-stage)]
    (when (and contains-version-published (not contains-version-draft))
      ($ Button
         {:on-click #(rf/dispatch [:manage.content-configuration-page.content-configuration.db/create-draft])
          :variant "text"
          :data-testid :create-draft-cfn-button
          :disabled create-stage-is-pending
          :start-icon ($ Icon "add")}
         "Create draft"))))

(defmodal confirm-delete ::confirm-delete
  [_]
  [deletion-confirmation
   {:on-submit #(rf/dispatch [:resource.content-function/delete-stage "draft"])
    :entity-name "draft content"
    :firm-warning? true}])

(defui delete-draft-button []
  (let [active-version-is-draft    (use-active-version? :draft)
        contains-version-published (use-contains-version? :published)
        delete-stage-is-pending    (use-resource-pending? :delete-stage)]
    (when (and active-version-is-draft contains-version-published)
      ($ Button
         {:on-click #(rf/dispatch [:modal/open {:id ::confirm-delete}])
          :variant "text"
          :data-testid :delete-draft-cfn-button
          :disabled delete-stage-is-pending
          :start-icon ($ Icon "delete")}
         "Delete draft"))))

(def cc (store/->DataScriptDBEntity [:content-configuration/id "default"]))

(def ^:private side-menu-item-cfg-entries
  (linked/map
   :placeholders (placeholder/list-cfg cc)
   :default-values (placeholder-expression/list-cfg-defaults cc)
   :dynamic-data (context-source/list-cfg cc)
   :rules (rule/list-cfg cc)))

(defui entity-view-panel [{:keys [route->cfg]}]
  (let [cfg (use-subscribe [:entity/current route->cfg])
        active-version? (use-subscribe [:resource.content-function-version/active-version? "published"])]
    ($ Drawer {:open (some? cfg)
               :variant "persistent"
               :anchor "right"
               :data-testid "right-panel"
               :sx #js {:position "relative"
                        :width (if (some? cfg) "50%" 0)
                        ".MuiDrawer-paper" #js {:position "unset"
                                                :borderRadius 0
                                                :backgroundColor "white"}}}
       (when (some? cfg)
         ($ Stack {:flex 1
                   :direction "column"
                   :data-component "entity-view-current"
                   :sx #js {:overflow "hidden"}}
            ($ ui.entity/view (cond-> cfg
                                active-version?
                                (assoc :entity/read-only? true))))))))

(defui view [_]
  (case (use-subscribe [:page.content-configuration/import-status])
    :failure
    ($ page/content-padding
       ($ import-failure))

    :success
    ($ Stack
       {:flex 1
        :direction "row"
        :overflow "hidden"}
       ($ Stack
          {:flex 1
           :direction "column"
           :data-testid "overview"}
          ($ Typography
             {:variant "h3"
              :sx #js {:px 3
                       :py 2}}
             "Rules overview")
          (r/as-element (:entity/content (rule/read-only-list-cfg cc))))
       ($ entity-view-panel {:route->cfg side-menu-item-cfg-entries})
       ($ side-menu/side-menu {:menu-entries-cfg side-menu-item-cfg-entries}))

    ;; :retrieving :importing
    ($ import-pending)))
